import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/IconShape.png'


const _hoisted_1 = { class: "adaptive-menu__header" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "adaptive-menu"
}
const _hoisted_4 = { class: "nav-button" }
const _hoisted_5 = { class: "nav-button__profile" }
const _hoisted_6 = { class: "nav-button__profile__box" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Профиль ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_router_link = _resolveComponent("router-link")
  const _component_SwitchLanguage = _resolveComponent("SwitchLanguage")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "nav-button__link",
        to: "/",
        exact: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_svg_icon, { name: "logoTRS" })
        ]),
        _: 1
      }),
      _createVNode(_component_SwitchLanguage),
      _createVNode("div", {
        class: "adaptive-menu-show",
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.active = !_ctx.active))
      }, [
        _hoisted_2
      ])
    ]),
    (_ctx.active)
      ? (_openBlock(), _createBlock("aside", _hoisted_3, [
          _createVNode("div", {
            class: "adaptive-close",
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.active = !_ctx.active))
          }, [
            _createVNode(_component_svg_icon, { name: "cancel" })
          ]),
          _createVNode("ul", _hoisted_4, [
            _createVNode("li", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_svg_icon, { name: "user_circle" }),
                _hoisted_7
              ])
            ]),
            _createVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "nav-button__link",
                to: "/admin",
                exact: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    name: "Alt4",
                    class: "nav-button__icon"
                  }),
                  _createTextVNode(_toDisplayString(_ctx.$t('adaptiveTop.mainSystem')), 1 /* TEXT */)
                ]),
                _: 1
              })
            ]),
            _createVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "nav-button__link",
                to: "/",
                exact: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    name: "Alt1",
                    class: "nav-button__icon"
                  }),
                  _createTextVNode(_toDisplayString(_ctx.$t('adminApp.toSite')), 1 /* TEXT */)
                ]),
                _: 1
              })
            ]),
            _createVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "nav-button__link",
                to: "/admin/user",
                exact: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    name: "Alt3",
                    class: "nav-button__icon"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('adminApp.users')), 1 /* TEXT */)
                ]),
                _: 1
              })
            ]),
            _createVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "nav-button__link",
                to: "/admin/import",
                exact: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    name: "region",
                    class: "nav-button__icon"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('adaptiveTop.import')), 1 /* TEXT */)
                ]),
                _: 1
              })
            ]),
            _createVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "nav-button__link",
                to: "/admin/articles",
                exact: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    name: "createareport",
                    class: "nav-button__icon"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('adminApp.articles')), 1 /* TEXT */)
                ]),
                _: 1
              })
            ]),
            _createVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "nav-button__link",
                to: "/admin/faq",
                exact: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    name: "Altnews",
                    class: "nav-button__icon"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('adaptiveTop.faq')), 1 /* TEXT */)
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}